import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import './detect/browser';
import { Waypoint } from 'waypoints/lib/noframework.waypoints.min.js'; // eslint-disable-line no-unused-vars
//import { slick } from 'slick-carousel/slick/slick.min.js'; // eslint-disable-line import/no-unresolved, no-unused-vars

/**
 * Add a class into the Body when the OTT param is present *
 */
import(
	/* webpackChunkName: "ott-body-classname.js" */
	'./util/ott-body-classname' )
	.then( ( { default: OttBodyClassname } ) => {
		OttBodyClassname.init();
	} );

/**
 * Initialize Adobe HeartBeat
 */
import(
	/* webpackChunkName: "adobeHeartBeat" */
	'./adobeHeartBeat/index' )
	.then( ( { default: index } ) => {
		index.init();
	} );

/**
 * Initialize Adobe HeartBeat object only on Articles (none Watch pages)
 * Remove the comments lines when we are ready
 */
/* eslint-disable no-tabs */
// if ( !document.body.classList.contains( 'watch-app' ) ) {
// 	import(
// 		/* webpackChunkName: "adobe-heartbeat-articles" */
// 		'./components/adobe-heartbeat' )
// 		.then( ( { default: AdobeHeartbeat } ) => {
// 			AdobeHeartbeat.init();
// 		} );
// }
/* eslint-enable no-tabs */

/**
 * Initialize Newsletter
 */
import(
	/* webpackChunkName: "newsletter" */
	'./components/newsletter' )
	.then( ( { default: Newsletter } ) => {
		Newsletter.init();
	} );

/**
 * Initialize mlp-update-links
 * only applies to nesn360-mlp page
 */
if ( document.body.classList.contains( 'page-template-page-nesn360-mlp' ) ) {
	import(
		/* webpackChunkName: "MLPLinks" */
		'./components/mlp-update-links' )
		.then( ( { default: MLPLinks } ) => {
			MLPLinks.init();
		} );
}


/* Used for copy clip functionality in social share */
import './components/copy-clipboard';

/**
 * Initialize Dropdowns
 */
if ( 'app' !== window.nesnVars.nesnView ) {
	import( /* webpackChunkName: "dropdown" */ './components/dropdown' )
		.then( ( { default: Dropdown } ) => {
			Dropdown.init();
		} );
}

/**
 * Initialize Search
 */
if ( 'app' !== window.nesnVars.nesnView ) {
	import( /* webpackChunkName: "search" */ './components/search' )
		.then( ( { default: Search } ) => {
			Search.init();
		} );
}

/**
 * Initialize Slider
 */
import( /* webpackChunkName: "slider" */ './components/slider' )
	.then( ( { default: Slider } ) => {
		Slider.init();
	} );



/**
 * Initialize Drawer Tabs
 */
if ( 'app' !== window.nesnVars.nesnView ) {
	import( /* webpackChunkName: "tabs" */ './components/tabs' )
		.then( ( { default: Tabs } ) => {
			Tabs.init();
		} );
}

/**
 * Initialize legacy fubo tv tracking
 */
import './legacy/fubo-tracking';

/**
 * Initialize Article Detail Page Scripts
 */
if ( document.body.classList.contains( 'single-post' ) && !document.body.classList.contains( 'article-2023' ) ) {

	/**
	 * Initialize Sticky Video
	 * only applies to Article Detail Page
	 */
	import( './components/article-detail-video.js' );

	/**
	 * Initialize inject/move the Tags tags and Sticky Video
	 * only applies to Article Detail Page
	 */
	import(
		/* webpackChunkName: "article-detail-tags" */
		'./components/article-detail-tags' )
		.then( ( { default: ArticleDetailTags } ) => {
			ArticleDetailTags.init();
		} );

	/**
	 * Initialize inject/move/duplicate the Trending Articles
	 * only applies to Article Detail Page
	 */
	import(
		/* webpackChunkName: "article-detail-trending" */
		'./components/article-detail-trending' )
		.then( ( { default: ArticleDetailTrending } ) => {
			ArticleDetailTrending.init();
		} );
}

/* eslint-enable no-tabs */


/**
 * Initialize Home Page Scripts
 */
if ( document.body.classList.contains( 'home' ) ) {

	/**
	 * Front Page Video Handling
	 * only applies to homepage
	 */
	import(
		/* webpackChunkName: "front-page-video" */
		'./components/front-page-video' )
		.then( ( { default: FrontPageVideo } ) => {
			FrontPageVideo.init();
		} );
}

/**
 * Viewport Video Handling
 * Do not apply on homepage
 * We will deactivate this one for now, to see the effect
 * on future CPMS
 */
/* eslint-disable no-tabs */
// if ( !document.body.classList.contains( 'home' ) ) {
// 	// Do not apply if there's not videos on the page
// 	if ( 'undefined' !== typeof window.videojs ) {
// 		import( './components/viewport-video' )
// 			.then( ( { default: ViewportVideo } ) => {
// 				ViewportVideo.init();
// 			} );
// 	}
// }
/* eslint-enable no-tabs */

/**
 * Nielsen ID3 Tags
 */
if (
	(
		(
			document.body.classList.contains( 'page-template-single-nesn_video' ) ||
			document.body.classList.contains( 'page-template-single-nesn_video-php' )
		) ||
		(
			document.body.classList.contains( 'watch-app' ) &&
			document.body.classList.contains( 'view_standard' )
		)
	)
) {
	import( /* webpackChunkName: "nielsen-tags" */
		'./nielsen-id3/nielsen-tags' )
		.then( ( { default: NielsenTags } ) => {
			NielsenTags.init();
		} );
}

/**
 * Initialize the inmarket calls on pages where the shortcode has been inserted, which is done
 * via a body class. See InMarketMessage.php
 */
if ( document.body.classList.contains( 'inmarket-message-shortcode' ) ) {
	import(
		/* webpackChunkName: "inmarket-message-shortcode" */
		'./shortcodes/inmarket-message' )
		.then( ( { default: InmarketMessage } ) => {
			InmarketMessage.init();
		} );
}
